import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { UpdateMenuCategoryRequestSchema } from '~/services/api/generated'
import { menuCategoryFieldsNormalizer } from '~/services/api/contracts/normalizers/menuCategoryFieldsNormalizer'

const schema = UpdateMenuCategoryRequestSchema.strict()

export const MenuCategoryUpdate = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(menuCategoryFieldsNormalizer, schema)
